// extracted by mini-css-extract-plugin
module.exports = {"TotalLine":"CartTotals_TotalLine__3eWUc","TotalLegend":"CartTotals_TotalLegend__3uY_x","TotalAmount":"CartTotals_TotalAmount__22tiX"};